import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { PageLayout } from '../components/global/PageLayout';
import { Section } from '../components/ui/PageIntro';
import { CONTACT, NAV_ITEMS, PAGE_META } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

/**
 * Named destinations rather than a bare "go home". Someone who mistyped a
 * URL or followed a dead link usually knows what they were after.
 */
export function NotFound() {
  useDocumentMeta({
    ...PAGE_META.notFound,
    path: '/404',
    noindex: true
  });
  const destinations = NAV_ITEMS.filter(item => item.to !== '/');
  return <PageLayout data-id="element-700" data-mp="1jw7xu3f94ekj">
      <Section className="py-16 sm:py-24" data-id="element-701" data-mp="1nvflvxnp8cvm">
        <div className="max-w-2xl" data-id="element-702" data-mp="1nu5ozbsl1aqk">
        <p className="mb-4 border-l-4 border-flame pl-3 text-sm font-black uppercase tracking-[0.2em] text-flame" data-id="element-703" data-mp="1nx9zeqwn52po">
          Error 404
        </p>
        <h1 className="font-bebas text-5xl leading-[0.9] tracking-wide text-ink sm:text-6xl" data-id="element-704" data-mp="1xstq8ywclb7k">
          Took a wrong turning
        </h1>
        <p className="mt-5 max-w-prose text-lg leading-relaxed text-ink/80" data-id="element-705" data-mp="1nx5d4yv37btj">
          That page isn't here. It may have moved, or the link might have a
          typo in it. Here's the way back.
        </p>

        <nav aria-labelledby="notfound-nav-heading" className="mt-10" data-id="element-706" data-mp="1ex9xagql6sn6">
          <h2 id="notfound-nav-heading" className="text-xs font-bold uppercase tracking-[0.14em] text-ink-muted" data-id="element-707" data-mp="19xni41r772bq">
            Try one of these
          </h2>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-708" data-mp="22m1fqgedjwmr">
            {destinations.map(item => <li key={item.to} data-id="element-709" data-mp="1xsqgp1ft0k5e">
                <Link to={item.to} className="block rounded-container border border-hairline bg-white px-5 py-4 font-bold text-ink transition-[border-color,color] duration-200 ease-out-expo hover:border-flame hover:text-flame focus:outline-none focus:ring-2 focus:ring-flame focus:ring-offset-2" data-id="element-710" data-mp="1xrov4315wf9f">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="mt-10 flex flex-col gap-3 border-t border-hairline pt-8 sm:flex-row sm:items-center" data-id="element-711" data-mp="39dmm1jcgr3iw">
          <Link to="/" className="inline-flex items-center justify-center rounded-container bg-flame px-6 py-3.5 text-sm font-black uppercase tracking-wide text-white transition-colors duration-200 ease-out-expo hover:bg-flame-dark focus:outline-none focus:ring-2 focus:ring-flame focus:ring-offset-2" data-id="element-712" data-mp="2vnap974xoglf">
            Back to the home page
          </Link>
          <a href={CONTACT.telephoneHref} className="inline-flex items-center justify-center gap-2 rounded-container border border-control px-6 py-3.5 text-sm font-bold text-ink transition-colors duration-200 ease-out-expo hover:bg-ink/5 focus:outline-none focus:ring-2 focus:ring-moss focus:ring-offset-2" data-id="element-713" data-mp="2cq9ibgrtk6eu">
            <Phone className="h-4 w-4 text-flame" aria-hidden="true" data-id="element-714" data-mp="1zgxwpemrjh1o" />
            Ring us on {CONTACT.telephone}
          </a>
        </div>
        </div>
      </Section>
    </PageLayout>;
}